import './src/styles/main.scss';
import './src/styles/global.css';

import { ThemeProvider, lightTheme } from '@comfama/comfama-ui';
import type { WrapPageElementBrowserArgs, RouteUpdateArgs } from 'gatsby';

import { TopContentProvider } from './src/context';

export const wrapPageElement = ({ element }: WrapPageElementBrowserArgs) => (
  <ThemeProvider customDarkTheme={lightTheme}>
    <TopContentProvider>{element}</TopContentProvider>
  </ThemeProvider>
);

export const onRouteUpdate = ({
  location: _location,
  prevLocation: _prevLocation
}: RouteUpdateArgs) => {
  setTimeout(() => {
    window.scrollTo({
      behavior: 'smooth',
      left: 0,
      top: 0
    });
  }, 1);
};

export const onClientEntry = () => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://cdn.comfama.com/comfama-ui/icons/icons.css?v=202510124123';
  document.head.appendChild(link);
};
